import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
var TurnOffLight = function () {
    function TurnOffLight(player) {
        _classCallCheck(this, TurnOffLight);
        this.player = player;
        this.initHeiMu();
    }
    _createClass(TurnOffLight, [
        {
            key: 'initHeiMu',
            value: function initHeiMu() {
                var _this = this;
                this.heiMuEl = document.createElement('div');
                this.heiMuEl.classList.add('heimu');
                this.heiMuEl.classList.add('dplayer-heimu-hide');
                document.body.append(this.heiMuEl);
                this.player.template.turnOffLight.addEventListener('click', function () {
                    _this.toggle();
                });
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.heiMuEl.classList.add('dplayer-heimu-hide');
                this.player.container.classList.remove('yplayer-heimu-visible');
                this.player.events.trigger('turnOff');
            }
        },
        {
            key: 'show',
            value: function show() {
                this.heiMuEl.classList.remove('dplayer-heimu-hide');
                this.player.container.classList.add('yplayer-heimu-visible');
                this.player.events.trigger('turnOn');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.heiMuEl.classList.contains('dplayer-heimu-hide')) {
                    this.show();
                } else {
                    this.hide();
                }
            }
        }
    ]);
    return TurnOffLight;
}();
export default TurnOffLight;